import React from 'react';

import { Maybe } from 'src/api';

export enum VerifierBillingSettingsTab {
  BillingRules = 'BillingRules',
  PaymentHistory = 'PaymentHistory',
}

export type VerifierBillingSettingsTabType = {
  label: string;
  key: VerifierBillingSettingsTab;
  component: React.ReactElement;
};

export enum VerifierBillingRulesFormFields {
  verificationOfIncome = 'voI',
  verificationOfEmployment = 'voE',
  reverification = 'reverification',
}

export type VerifierBillingRulesFormValues = {
  [VerifierBillingRulesFormFields.verificationOfIncome]: number;
  [VerifierBillingRulesFormFields.verificationOfEmployment]: number;
  [VerifierBillingRulesFormFields.reverification]: number;
};

export type VerifierBillingRulesFormDataType = {
  voI: Maybe<number> | undefined;
  voE: Maybe<number> | undefined;
  reverification: Maybe<number> | undefined;
};

export type VerifierBillingRulesInputField = {
  name: VerifierBillingRulesFormFields;
  title: string;
  description: string;
  label: string;
};
